export default __webpack_public_path__ + "static/dima_and_book-9808bcea8d34504a293d1e865e0be67b.jpg";